export const SCHEMA_CONTEXT = 'https://schema.org'
export const SCHEMA_DEFAULT_LANGUAGE = 'pt-BR'
export const WEBMOTORS_ORGANIZATION_ID = 'https://www.webmotors.com.br/#organization'
export const KM_UNIT_CODE = 'KMT'
export const VEHICLE_SCHEMA_ID_FRAGMENT = '#veiculo'
